import React, { FC, FormEvent } from 'react'

import { useMutation } from '@apollo/client'

import useEvent from 'Hooks/useEvent'
import { ReactComponent as Send } from 'Icons/send.svg'
import { ReactComponent as X } from 'Icons/x.svg'
import { SIGN_UP } from 'Pages/Chat/const/gql/signUp'
import { ChatCustomer } from 'Types'
import { signUpCallback } from 'Utils/signUpCallback'

import styles from './index.module.less'

interface Props {
  hideSignupForm(): void
}

const SignUpForm: FC<Props> = ({ hideSignupForm }) => {
  const [signUp] = useMutation(SIGN_UP, {
    update(cache, { data }) {
      cache.modify({
        fields: {
          currentCustomer() {
            return {
              ...(data.signUpCustomer.user.customer as ChatCustomer),
              __typename: 'Customer',
            }
          },
        },
      })
    },
  })

  const handleSubmit = useEvent((e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    const input: Record<string, unknown> = {}
    formData.forEach((value, key) => {
      input[key] = value
    })

    void signUp({ variables: { input } }).then(() => {
      signUpCallback()
      hideSignupForm()
    })
  })

  return (
    <li className="chatBox__dialog--message msgFrom">
      <X className={`sociavore-icon ${styles.closeIcon}`} onClick={hideSignupForm} />
      <div className="chatBox__dialog--message-body">
        <div className="chat-sign-up">
          <div className="chat-sign-up__caption">
            <p className="chat-sign-up__paragraph">
              Thanks for messaging us. We try to be as responsive as possible. We&apos;ll get back to you soon.
            </p>
            <p className="chat-sign-up__paragraph mb-3">
              In case we don&apos;t reply to you quick enough, give us another way to reach you.
            </p>
          </div>
          <form className="chat-sign-up__form" onSubmit={handleSubmit}>
            <input
              required
              aria-label="First Name"
              className="form-control"
              name="firstName"
              placeholder="Your first name"
              type="text"
            />
            <input
              required
              aria-label="Last Name"
              className="form-control"
              name="lastName"
              placeholder="Your last name"
              type="text"
            />
            <input
              required
              aria-label="Email"
              className="form-control mb-3"
              name="email"
              placeholder="Your e-mail"
              type="email"
            />
            <button aria-label="Send" className="btn btn-accent" type="submit">
              <Send />
              <span>Send</span>
            </button>
          </form>
        </div>
      </div>
    </li>
  )
}

export default SignUpForm
